/* eslint-disable @typescript-eslint/no-explicit-any */
import { IFoldersWithMaterial } from '@sdk/contracts';
import { FC, ReactNode } from 'react';

import { MaterialActions } from '../MaterialActions';
import { MaterialElement } from '../MaterialElement';

import { SortableProvider } from '@/components/SortableProvider';
import { useLocalCourse, useProfile } from '@/store';

type Props = {
  folder: IFoldersWithMaterial;
};

export const MaterialSorter: FC<Props> = ({ folder }) => {
  const { course, reorderCourseMaterial } = useLocalCourse();
  const {
    roleCheck: { isManager }
  } = useProfile();

  if (!course) return null;

  const onReorder = (items: ReactNode[]) => {
    const newMaterialOrder = items.map(item => (item as any).props._id);
    reorderCourseMaterial({
      courseId: course._id,
      folderId: folder._id,
      newMaterialOrder
    });
  };

  return (
    <>
      {isManager && <MaterialActions folder={folder} material={folder.material} />}
      <SortableProvider
        onReorder={onReorder}
        zIndex={20}
        droppableId="material"
        isDragDisabled={!isManager}>
        {folder.material.map(mat => (
          <MaterialElement key={mat._id} {...mat} file={mat} />
        ))}
      </SortableProvider>
    </>
  );
};
